@if (showLocationSelector) {
  <div id="location-select" class='d-flex align-items-center'>
    <div class="locationIcon" [ngStyle]="{'margin-right': '15px'}">
      <img [src]="'/icons/'+baseSiteId+'/location.svg'" alt="location_icon">
    </div>
    <div class="locationDetails">
        <div class="selected-loc" [ngClass]="{'selected-loc-underlined':getTitle() == 'Select a location'}" (click)="showChangeOption && getTitle() == 'Select a location' ?
            openModal(content) : $event.preventDefault()">
        {{getTitle()}}
      </div>
      @if (showChangeOption && getTitle() != 'Select a location') {
        <div (click)="openModal(content)">Change
          location
        </div>
      }
    </div>
  </div>
}

<!-- modal content -->
<ng-template #content let-modal>
  <div class="modal-header">
    <h3 class="modal-title">Select location</h3>
    @if (!hideCloseBtn) {
      <button class="btn-close"
        [ngStyle]="{'background-image': 'url(/icons/'+baseSiteId+'/close.svg)'}"
      (click)="searchKeyword = null;noResults = false;modal.dismiss();hideReturnText=false"></button>
    }
  </div>
  <div class="modal-body">
    @if (hideCloseBtn && !hideReturnText) {
      <div class="returns-heading">
        <h4>To initiate your return, please select a location:</h4>
      </div>
    }
    <div [ngStyle]="{'position': 'relative'}">
      <input type="text"
        [ngStyle]="{'background-image': 'url(/icons/'+baseSiteId+'/search_new.svg)'}"
        name="searchbox" #searchbox placeholder="Filter by location name, city, zip code"
        [(ngModel)]="searchKeyword" (input)="searchLoc(searchbox.value)">

      @if (searchbox.value) {
        <img src="/icons/close.svg" alt="close-icon"
          (click)="searchbox.value = '';searchKeyword = null;searchLoc('')">
      }
    </div>
    @if (isMultiSelectionPossible || showGovFilter) {
      <hr [ngStyle]="{'margin': '10px 0'}">
    }
    @if (showError) {
      <div class="error">Please select one government or one or more non-government locations</div>
    }
    <div class="loc-results">
      @if (!noResults) {
        <div class="selection-btns d-flex flex-row"
          [ngStyle]="{'border-top': showError ? '1px solid #e5e9ec' : 'none'}">
          @if (isMultiSelectionPossible) {
            <div class="loc loc-group  d-flex flex-row align-items-end">
              <input type="checkbox" id="checkBox" name="all" (change)="filterLocations($event,'selectAll')"
                class="col-2">
              <span class="checkmark"></span>
              <label>Select all</label>
            </div>
          }
          @if (showGovFilter) {
            <div class="loc loc-group  d-flex flex-row align-items-end">
              <input type="checkbox" id="checkBox" name="gov" (change)="filterLocations($event,'gov')"
                class="col-2">
              <span class="checkmark"></span>
              <label>Government location</label>
            </div>
          }
        </div>
      }
      @if (!testxxx?.length || noResults) {
        <label class="no-results">No results</label>
      }
      <!-- new implementation -->
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <!-- This is the tree node template for leaf nodes -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [ngStyle]="{'display': node.display}">
          @if (!showOnlyGovLocs || (showOnlyGovLocs && node.govLocation)) {
            <div class="loc d-flex flex-row align-items-start w-100"
              >
              <input type="checkbox" id="checkBox" name="assignedLocation" class="col-2"
                [checked]="node.checked" (change)="filterLocations($event, 'individualLoc', node)">
              <span class="checkmark"></span>
              <label class="col-10" [ngStyle]="{'font': '12px/17px LexendDeca-Regular'}">
                <span>{{node.facilityName}}@if (node.govLocation) {
                  <span
                  >-GOV</span>
                }&nbsp;({{node.accountNumber}})&nbsp;{{node.formattedAddress}},&nbsp;{{node.phoneNo}}</span>
              </label>
            </div>
          }
        </mat-tree-node>

        <!-- This is the tree node template for expandable nodes -->
        <mat-tree-node *matTreeNodeDef="let node;when:hasChild" matTreeNodePadding
          [ngStyle]="{'display': node.display}">

          <div class="loc d-flex flex-row align-items-start w-100">
            @if (isMultiSelectionPossible) {
              <input type="checkbox" id="checkBox" name="assignedLocation" class="col-2"
                [checked]="node.checked"
                (change)="selectChilds($event,node)">
            }
            @if (isMultiSelectionPossible) {
              <span class="checkmark"></span>
            }
            <label class="col-10" [ngStyle]="{'font': '16px/17px LexendDeca-Bold'}">
              {{node.name}}
            </label>
            <img src="/icons/vsh/{{ (treeControl.isExpanded(node) ? 'minus-green' : 'plus-green') + '.png'}}"
              matTreeNodeToggle alt="{{treeControl.isExpanded(node) ? 'minus' : 'plus'}}">
          </div>
        </mat-tree-node>
      </mat-tree>

    </div>

  </div>
  <div class="modal-footer">
    <button class="btn-primary" [disabled]="checkBtnVisibility()" ngbAutofocus
    (click)="updateLocation()">Done</button>
  </div>
</ng-template>
